import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { login } from "../services/auth";
import { useAuth } from "services/theme/useAuth";
import {
  TextInput,
  PasswordInput,
  Button,
  Paper,
  Title,
  Container,
  Alert,
} from "@mantine/core";
import { IconAlertCircle } from "@tabler/icons-react";

export const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    if (user) {
      if (email === "admin") {
        localStorage.setItem("admin", "true");
      } else if (email === "jure") {
        localStorage.setItem("manager", "true");
      }
      navigate("/", { replace: true });
    }
  }, [user, navigate]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      await login(`${email}@dostava.com`, password).then(() => {
        const timestamp = Date.now();
        localStorage.setItem("loginTimestamp", timestamp.toString());
        if (email === "admin") {
          localStorage.setItem("admin", "true");
        }
        if (email === "jure") {
          localStorage.setItem("manager", "true");
        }
        navigate("/", { replace: true });
      });
    } catch (err: any) {
      setError(err.message || "Prijava nije uspjela");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container size={420} my={40}>
      <Title ta="center">Prijava</Title>

      <Paper
        withBorder
        shadow="md"
        p={30}
        mt={30}
        radius="md"
        component="form"
        onSubmit={handleSubmit}
      >
        {error && (
          <Alert icon={<IconAlertCircle size={16} />} color="red" mb="sm">
            {error}
          </Alert>
        )}

        <TextInput
          label="Korisničko ime"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          mb="sm"
        />

        <PasswordInput
          label="Lozinka"
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          mb="md"
        />

        <Button type="submit" fullWidth loading={loading}>
          Prijava
        </Button>
      </Paper>
    </Container>
  );
};
